import { HttpClient } from '@angular/common/http';
import { inject, Injectable, Injector } from '@angular/core';
import { environment } from '../../environments/environment';
import { BehaviorSubject, EMPTY, ReplaySubject, take, tap } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { Dialog } from '@angular/cdk/dialog';
import { SignInModalComponent } from '../../app/modals/sign-in-modal/sign-in-modal.component';

@Injectable({
  providedIn: 'root',
})
export class WorkOfArtService {
  constructor() {}

  private _backendUrl = environment.backendUrl;
  private _httpClient = inject(HttpClient);

  private _worksOfArt: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  private _workOfArt: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  private _favoriteWorksOfArt: BehaviorSubject<any> = new BehaviorSubject<any>(
    [],
  );

  private _configCallsPage: ReplaySubject<any> = new ReplaySubject<any>(1);

  dialog = inject(Dialog);

  get worksOfArt$() {
    return this._worksOfArt.asObservable();
  }
  get workOfArt$() {
    return this._workOfArt.asObservable();
  }

  get configCallsPage$() {
    return this._configCallsPage.asObservable();
  }

  get favoriteWorksOfArt$() {
    return this._favoriteWorksOfArt.asObservable();
  }

  set worksOfArt(worksOfArt: any) {
    this._worksOfArt.next(worksOfArt);
  }
  set workOfArt(workOfArt: any) {
    this._workOfArt.next(workOfArt);
  }
  set favoriteWorksOfArt(favoriteWorksOfArt: any) {
    this._favoriteWorksOfArt.next(favoriteWorksOfArt);
  }

  set configCallsPage(configCallsPage: any) {
    this._configCallsPage.next(configCallsPage);
  }
  private _injector = inject(Injector);
  private get authService(): AuthService {
    return this._injector.get(AuthService);
  }

  // getvalue

  getWorkOfArts(
    page: any,
    search: {
      name: string;
      category: string;
    },
  ) {
    return this._httpClient
      .get(`${this._backendUrl}client/works-of-art`, {
        params: {
          page,
          ...search,
        },
      })
      .pipe(
        tap((response: any) => {
          // console.log(
          //   '%csrc/core/workOfArt/workOfArt.service.ts:57 response',
          //   'color: #007acc;',
          //   response.payload.worksOfArt.length
          // );
          if (response.payload.worksOfArt.length === 0) {
            this._worksOfArt.next([]);
            return;
          }
          const worksOfArtx = this._worksOfArt.getValue();
          // console.log(
          //   '%csrc/core/workOfArt/workOfArt.service.ts:67 artistx',
          //   'color: #007acc;',
          //   artistx
          // );
          // const worksOfArt = artistx.concat(response.payload.worksOfArt);
          this._worksOfArt.next([
            ...worksOfArtx,
            ...response.payload.worksOfArt,
          ]);
        }),
      );
  }
  getPagesWorkOfArts(search: any = {}) {
    return this._httpClient
      .get(`${this._backendUrl}client/works-of-art/pages`, {
        params: {
          ...search,
        },
      })
      .pipe(
        tap((response: any) => {
          this._configCallsPage.next(response.payload);
        }),
      );
  }

  clearWorkOfArts() {
    this._worksOfArt.next([]);
  }

  getActiveCollectiveActions() {
    return this._httpClient.get(
      `${this._backendUrl}client/works-of-art/collective-actions/active`,
    );
  }

  getDetailsWorkOfArt(id: string) {
    return this._httpClient
      .get(`${this._backendUrl}client/works-of-art/${id}`)
      .pipe(
        take(1),
        tap((response: any) => {
          this._workOfArt.next(response.payload);
        }),
      );
  }

  clearFavoriteWorksOfArt() {
    const worksOfArtx = this._worksOfArt.getValue();
    this._worksOfArt.next(
      worksOfArtx.map((workOfArt: any) => {
        return {
          ...workOfArt,
          isFavorite: false,
        };
      }),
    );

    this._favoriteWorksOfArt.next([]);
  }

  addFollowingArtistToWorksOfArt(artistId: string) {
    const worksOfArtx = this._workOfArt.getValue();
    if (!worksOfArtx) {
      return;
    }
    this._workOfArt.next({
      ...worksOfArtx,
      artist: {
        ...worksOfArtx.artist,
        isFollowing: true,
      },
    });
  }

  removeFollowingArtistToWorksOfArt(artistId: string) {
    const worksOfArtx = this._workOfArt.getValue();
    if (!worksOfArtx) {
      return;
    }
    this._workOfArt.next({
      ...worksOfArtx,
      artist: {
        ...worksOfArtx.artist,
        isFollowing: false,
      },
    });
  }

  addFavoriteWorkOfArt(workOfArtId: string) {
    // check if user is authenticated
    if (!this.authService.authenticated) {
      // If not authenticated, open the sign-in modal
      this.dialog.open(SignInModalComponent, { data: {} });
      return EMPTY;
    }
    // update workOfArt in list
    const workOfArtx = this._workOfArt.getValue();
    if (!workOfArtx) {
      return EMPTY;
    }
    this._workOfArt.next({
      ...workOfArtx,
      workOfArt: {
        ...workOfArtx.workOfArt,
        isFavoriting: true,
      },
    });

    // {{host}}/client/works-of-art/:id/favorite

    return this._httpClient
      .post(
        `${this._backendUrl}client/works-of-art/${workOfArtId}/favorite`,
        {},
      )
      .pipe(
        take(1),
        tap({
          next: (response: any) => {
            // Update the workOfArt with the new favorite statusconst
            const favoriteWorksOfArtx =
              this._favoriteWorksOfArt.getValue() || [];
            this._favoriteWorksOfArt.next([
              ...favoriteWorksOfArtx,
              {
                ...workOfArtx.workOfArt,
                isFavoriting: true,
              },
            ]);

            // Handle the response if needed
          },
          error: (error: any) => {
            console.error('Error adding favorite work of art:', error);
            const worksOfArtx = this._workOfArt.getValue();
            this._workOfArt.next({
              ...worksOfArtx,
              workOfArt: {
                ...worksOfArtx.workOfArt,
                isFavoriting: false,
              },
            });
          },
        }),
      );
  }

  removeFavoriteWorkOfArt(workOfArtId: string) {
    // check if user is authenticated
    if (!this.authService.authenticated) {
      // If not authenticated, open the sign-in modal
      this.dialog.open(SignInModalComponent, { data: {} });
      return EMPTY;
    }
    // update workOfArt in list
    const workOfArtx = this._workOfArt.getValue();

    if (!workOfArtx) {
      return EMPTY;
    }

    this._workOfArt.next({
      ...workOfArtx,
      workOfArt: {
        ...workOfArtx.workOfArt,
        isFavoriting: false,
      },
    });

    // {{host}}/client/works-of-art/:id/favorite delete

    return this._httpClient
      .delete(`${this._backendUrl}client/works-of-art/${workOfArtId}/favorite`)
      .pipe(
        take(1),
        tap({
          next: (response: any) => {
            // Handle the response if needed

            const favoriteWorksOfArtx =
              this._favoriteWorksOfArt.getValue() || [];

            this._favoriteWorksOfArt.next(
              favoriteWorksOfArtx.filter(
                (workOfArt: any) => workOfArt._id !== workOfArtId,
              ),
            );
          },
          error: (error: any) => {
            const worksOfArtx = this._workOfArt.getValue();
            this._workOfArt.next({
              ...worksOfArtx,
              workOfArt: {
                ...worksOfArtx.workOfArt,
                isFavoriting: true,
              },
            });
          },
        }),
      );
  }
  getFavoriteWorksOfArt(page: number = 1) {
    // check if user is authenticated
    if (!this.authService.authenticated) {
      this.dialog.open(SignInModalComponent, { data: {} });
      this._favoriteWorksOfArt.next([]);
      return EMPTY;
    }
    return this._httpClient
      .get(`${this._backendUrl}client/works-of-art/favorites`, {
        params: {
          page,
        },
      })
      .pipe(
        take(1),
        tap((response: any) => {
          const worksOfArtx = this._favoriteWorksOfArt.getValue();
          if (response.payload.worksOfArt.length === 0) {
            this._favoriteWorksOfArt.next([]);
            return;
          }

          this._favoriteWorksOfArt.next([
            ...worksOfArtx,
            ...response.payload.worksOfArt,
          ]);
        }),
      );
  }
}
